import { PrizePoolAction, WinnersAction } from "../actions";
import { ApiCaller, Utils } from "../../config";
import { put } from "redux-saga/effects";
import { GET_PRIZEPOOL_DETAILS_ENDPOINT, GET_PRIZEPOOL_ENDPOINT, WINNER_ENDPOINT, WINNER_UPDATE_ENDPOINT } from "../../config/variables";

export default class PrizePoolMiddleware {
  static *GetPrizePool() {
    try {
      let res = yield ApiCaller.Get(
        `${GET_PRIZEPOOL_ENDPOINT}`
      );
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetPrizePool_Success(res?.data?.data));
      }

    } catch (err) { }
  }
  static *GetPrizePoolDetail({id, cb}) {
    try {
      let res = yield ApiCaller.Get(
        `${GET_PRIZEPOOL_DETAILS_ENDPOINT}${id}/prize-pool`
      );
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetPrizePool_Detail_Success(res?.data?.data));
        cb()
      }

    } catch (err) { }
  }

  static *UpdatePrizePool_Detail({payload, cb}) {
    console.log("payload", payload, cb);
    const { requiredUsers, id } = payload;
    try {
      let res = yield ApiCaller.Patch(
        `${GET_PRIZEPOOL_DETAILS_ENDPOINT}${id}/prize-pool`,{},{requiredUsers}
      );
      if (res?.status == 200) {
        yield put(PrizePoolAction.UpdatePrizePool_Detail_Success(res?.data?.data));
        cb()
      }

    } catch (err) { }
  }
}
